import { useEffect, useState } from 'react'
import Breadcrumb from './Breadcrumb'
import getImageUrl from './get-image-url.js'
import { Icon } from '@iconify/react'

import PureModal from 'react-pure-modal'
import 'react-pure-modal/dist/react-pure-modal.min.css'

import { useMediaQuery } from 'react-responsive'

import Btn from './BtnText.jsx'

import apiFetch from '@wordpress/api-fetch'

import parse from 'html-react-parser'

import { motion, AnimatePresence, delay } from 'framer-motion'
import clsx from 'clsx'

const fadeInBottom = {
  hidden: {
    opacity: 0,
    y: 80,
  },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: {
      y: {
        duration: 1.3,
        ease: [0.165, 0.84, 0.44, 1],
        delay: i,
      },
      opacity: {
        duration: 0.3,
        delay: i,
      },
    },
  }),
}

const childVariantsBg = {
  hidden: { backgroundColor: '#003475', scaleX: 0, originX: 0, width: '100%', height: '100%' },
  shown: {
    scaleX: [0, 1, 1, 0],
    originX: [0, 0, 1, 1],
    transition: {
      duration: 0.6,
    },
  },
}

const Card = (props) => {
  const [modal, setModal] = useState(false)

  const isPC = useMediaQuery({
    query: '(min-width: 1024px)',
  })

  return (
    <motion.div
      style={{
        width: 'fit-content',
      }}
      variants={fadeInBottom}
      initial="hidden"
      whileInView="visible"
      custom={props.delay}
      viewport={{
        once: true,
        amount: 0.5,
      }}
    >
      <PureModal
        isOpen={modal}
        closeButtonPosition="header"
        onClose={() => {
          setModal(false)
          return true
        }}
        width={isPC ? '888px' : 'calc(100vw - 40px)'}
        closeButton={
          <Icon
            icon="material-symbols:close"
            color="#2964b6"
            width="45"
          />
        }
      >
        <div className="modal">
          <div className="ribbon modal-ribbon">{props.ribbon}</div>
          <div className="card-header">
            <img
              // src="https://picsum.photos/522/608"
              src={props.image}
              alt=""
              className="max-w-[522px] w-full aspect-[522/608]"
            />
          </div>
          <div className="card-body">
            <div className="card-body-inner">
              <p className="year">{props.year}</p>
              <p className="name">{props.name}</p>
              <p className="name-en">{props.nameEN}</p>
              <p>{parse(props.children)}</p>
            </div>
          </div>
        </div>
      </PureModal>
      <button
        className={`card ${props.className}`}
        onClick={() => setModal(true)}
      >
        <div className="ribbon">{props.ribbon}</div>
        <div className="card-header">
          <img
            // src={isPC ? 'https://picsum.photos/314/364' : 'https://picsum.photos/226/264'}
            src={props.image}
            alt=""
            className={
              isPC
                ? 'max-w-[314px] w-full h-full object-cover aspect-[314/364]'
                : 'max-w-[226px] w-full h-full object-cover aspect-[226/264]'
            }
          />
        </div>
        <div className="card-body">
          <div className="card-body-inner">
            <p className="year">{props.year}</p>
            <p className="name">{props.name}</p>
            <p className="name-en">{props.nameEN}</p>
          </div>
        </div>
      </button>
      <style
        jsx
        global
      >{`
        .panel {
          min-height: 98vh;
        }
        .pure-modal .close {
          cursor: url(${getImageUrl('cursor-pointer.cur')}), auto;
        }
      `}</style>
      <style jsx>{`
        .card {
          box-shadow: 8px 8px 10px #00347566;
          position: relative;
          display: block;
        }
        .ribbon {
          background: #003475 0% 0% no-repeat padding-box;
          font: normal normal bold 24px/35px Noto Sans JP;
          color: #f9d022;
          padding: 8px 18px;
          position: absolute;
          top: -32px;
          right: -20px;
        }
        .ribbon.modal-ribbon {
          top: 20px;
        }
        .card-body {
          display: flex;
          justify-content: center;
          align-items: center;
          background: #fff;
          padding: 18px 0;
        }
        .year {
          text-align: center;
          font: normal normal bold 20px/29px Noto Sans JP;
          color: #003475;
          opacity: 0.5;
        }
        .name {
          text-align: center;
          font: normal normal bold 28px/40px Noto Sans JP;
          color: #003475;
        }
        .name-en {
          text-align: center;
          font: normal normal bold 16px/24px Noto Sans JP;
          color: #003475;
          opacity: 0.2;
        }
        @media screen and (min-width: 1024px) {
          .card {
            box-shadow: 8px 8px 10px #00347566;
            position: relative;
            display: block;
          }
          .ribbon {
            background: #003475 0% 0% no-repeat padding-box;
            font: normal normal bold 24px/35px Noto Sans JP;
            color: #f9d022;
            padding: 8px 18px;
            position: absolute;
          }
          .card-body {
            display: flex;
            justify-content: center;
            align-items: center;
            background: #fff;
            padding: 18px 0;
          }
          .year {
            text-align: center;
            font: normal normal bold 20px/29px Noto Sans JP;
            color: #003475;
            opacity: 0.5;
          }
          .name {
            text-align: center;
            font: normal normal bold 28px/40px Noto Sans JP;
            color: #003475;
          }
          .name-en {
            text-align: center;
            font: normal normal bold 16px/24px Noto Sans JP;
            color: #003475;
            opacity: 0.2;
          }
        }
      `}</style>
    </motion.div>
  )
}

const Card2 = (props) => {
  return (
    <motion.div
      initial="hidden"
      whileInView="shown"
      viewport={{
        once: true,
        amount: 0.5,
      }}
      style={{
        position: 'relative',
      }}
    >
      <motion.div
        variants={{
          hidden: { opacity: 0 },
          shown: {
            opacity: 1,
            transition: {
              delay: 0.5,
            },
          },
        }}
      >
        <div className={`card ${props.className}`}>
          <div className="card-header">
            <img
              src={props.image}
              alt=""
            />
          </div>
          <div className="card-body">
            <div className="card-body-inner">
              <p className="title">{props.title}</p>
              <p className="title-en">{props.nameEN}</p>
              <Btn
                href={props.href}
                white2={true}
                className={'lg:mt-[40px] mt-[min(calc(40vw/7.5),20px)] z-10'}
              >
                もっと見る
              </Btn>
            </div>
          </div>
        </div>
      </motion.div>

      <div className="absolute inset-0 m-auto w-full h-full">
        <motion.div variants={childVariantsBg}></motion.div>
      </div>
      <style jsx>{`
        @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;500;600;700&family=Oswald:wght@400;700&display=swap');
        .card-body {
          display: flex;
          justify-content: center;
          align-items: center;
          background: #fff;
          padding: min(calc(50vw / 7.5), 25px) 0;
          background: transparent
            linear-gradient(
              157deg,
              #003475 0%,
              #003678 27%,
              #003e82 48%,
              #004b93 68%,
              #005daa 86%,
              #0070c2 100%
            )
            0% 0% no-repeat padding-box;
        }
        .title {
          text-align: center;
          font: normal normal bold calc(40vw / 7.5) Noto Sans JP;
          color: #ffffff;
        }
        .title-en {
          font-family: 'Oswald', sans-serif;
          text-align: center;
          font: normal normal bold min(calc(35vw / 7.5), 18px);
          color: #ffffff;
          margin-top: 6px;
        }
        @media screen and (min-width: 1024px) {
          .card-body {
            display: flex;
            justify-content: center;
            align-items: center;
            background: #fff;
            padding: 132px 0;
            background: transparent
              linear-gradient(
                157deg,
                #003475 0%,
                #003678 27%,
                #003e82 48%,
                #004b93 68%,
                #005daa 86%,
                #0070c2 100%
              )
              0% 0% no-repeat padding-box;
          }
          .title {
            text-align: center;
            font: normal normal bold 50px/45px Noto Sans JP;
            color: #ffffff;
          }
          .title-en {
            font-family: 'Oswald', sans-serif;
            text-align: center;
            font: normal normal bold 20px/45px;
            color: #ffffff;
          }
        }
      `}</style>
    </motion.div>
  )
}

const BusinessBox = (props) => {
  const isPC = useMediaQuery({ query: '(min-width: 1024px)' })

  return (
    <>
      <div className="box">
        {isPC ? (
          <>
            <div className="h-[calc(172vw/19.2)]">
              <div className="icon">
                <img
                  src={props.icon}
                  alt=""
                />
              </div>
            </div>
            <div
              className="title"
              dangerouslySetInnerHTML={{ __html: props.title }}
            ></div>
          </>
        ) : (
          <div className="flex justify-between items-center">
            <div className="icon max-h-[calc(170vw/7.5)]">
              <img
                src={props.icon}
                alt=""
              />
            </div>
            <div className="title">{parse(props.title)}</div>
          </div>
        )}

        <div className="paragrah">{props.children}</div>
      </div>

      <style jsx>
        {`
          .box {
            background: #003475 0% 0% no-repeat padding-box;
            border-radius: 30px;
            padding: 30px;
            display: flex;
            flex-direction: column;
            gap: 25px;
          }
          .icon {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100%;
          }
          .icon img {
            height: 100%;
            width: auto;
            max-height: 172px;
            max-width: 152px;
            object-fit: contain;
          }
          .title {
            font: normal normal bold calc(35vw / 7.5) Noto Sans JP;
            color: #ffffff;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .paragrah {
            font: normal normal normal calc(35vw / 7.5) Noto Sans JP;
            line-height: 2;
            color: #ffffff;
            flex-grow: 1;
          }
          @media screen and (min-width: 1024px) {
            .box {
              background: #003475 0% 0% no-repeat padding-box;
              border-radius: 30px;
              max-width: min(calc(350vw / 14.4), 350px);
              display: flex;
              flex-direction: column;
              gap: calc(25vw / 19.2);
            }
            .icon {
              display: flex;
              justify-content: center;
              align-items: flex-end;
              height: 100%;
            }
            .title {
              height: min(150px, calc(150vw / 19.2));
              font: normal normal bold clamp(22px, calc(30vw / 19.2), 30px) Noto Sans JP;
              color: #ffffff;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            .paragrah {
              font: normal normal normal clamp(16px, calc(22vw / 19.2), 22px) Noto Sans JP;
              line-height: 2;
              color: #ffffff;
              flex-grow: 1;
            }
          }
        `}
      </style>
    </>
  )
}

const BusinessBoxVer2 = (props) => {
  return (
    <>
      <motion.div
        variants={fadeInBottom}
        initial="hidden"
        whileInView="visible"
        viewport={{
          once: true,
          amount: 0.5,
        }}
        className="max-w-[254px] w-full"
        custom={props.delay}
      >
        <div className="box">
          <div className={clsx('icon', props.iconClassName)}>
            <img
              src={props.icon}
              alt=""
            />
          </div>
          <div className="title">{parse(props.title)}</div>
        </div>
      </motion.div>
      <style jsx>
        {`
          .box {
            background: #003475 0% 0% no-repeat padding-box;
            border-radius: 20px;
            max-width: 254px;
            width: 100%;
            height: auto;
            display: grid;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            grid-template-rows: 1fr 16vw;
            aspect-ratio: 1;
          }
          .icon {
            aspect-ratio: 1;
            width: 19.6875vw;
            max-width: 126px;
            display: flex;
            justify-content: center;
            align-items: flex-end;
            margin-inline: auto;
          }
          .icon img {
            max-height: 100%;
            object-fit: contain;
          }
          .title {
            font-size: clamp(14px, 3vw, 32px);
            font-weight: bold;
            color: #ffffff;
            display: flex;
            align-items: center;
            justify-content: center;
            height: 2.8em;
            font-weight: bold;
            line-height: 1.25;
            text-align: center;
          }
          @media screen and (min-width: 1024px) {
            .box {
              display: flex;
              padding: 16px;
              max-width: 254px;
              padding: 16px 12px;
            }
            .icon {
              width: 160px;
              height: 120px;
              align-items: center;
            }
            .title {
              font-size: clamp(22px, calc(34vw / 19.2), 28px);
              padding-top: 12px;
              line-height: 1.125;
            }
          }
        `}
      </style>
    </>
  )
}

const JobBox = (props) => {
  return (
    <>
      <motion.div
        initial="hidden"
        whileInView="shown"
        viewport={{
          once: true,
          amount: 0.5,
        }}
        style={{
          position: 'relative',
        }}
      >
        <motion.div
          variants={{
            hidden: { opacity: 0 },
            shown: { opacity: 1, transition: { delay: 0.5 } },
          }}
        >
          <div className="box">
            {props.children}
            {props.disable && (
              <>
                <div className="disable"></div>
                <p className="disable-text">現在募集は終了しています</p>
              </>
            )}
          </div>
        </motion.div>

        <div className="absolute inset-0 m-auto w-full h-full">
          <motion.div variants={childVariantsBg}></motion.div>
        </div>
      </motion.div>
      <style jsx>
        {`
          .box {
            display: flex;
            height: 100%;
            position: relative;
            flex-direction: column;
          }
          .disable {
            text-align: center;
            width: 100%;
            height: 100%;
            background: #4d4d4d 0% 0% no-repeat padding-box;
            mix-blend-mode: multiply;
            position: absolute;
            top: 0;
            left: 0;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .disable-text {
            font: normal normal bold calc(38vw / 7.5) Noto Sans JP;
            color: #ffffff;
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          @media screen and (min-width: 1024px) {
            .box {
              display: flex;
              height: 100%;
              position: relative;
              flex-direction: row;
            }
            .disable {
              text-align: center;
              width: 100%;
              height: 100%;
              background: #4d4d4d 0% 0% no-repeat padding-box;
              mix-blend-mode: multiply;
              position: absolute;
              top: 0;
              left: 0;
              display: flex;
              justify-content: center;
              align-items: center;
            }
            .disable-text {
              font: normal normal bold 50px/100px Noto Sans JP;
              color: #ffffff;
              width: 100%;
              height: 100%;
              position: absolute;
              top: 0;
              left: 0;
              display: flex;
              justify-content: center;
              align-items: center;
            }
          }
        `}
      </style>
    </>
  )
}

const JobBoxImage = (props) => {
  return (
    <>
      <div className="image"></div>
      <style jsx>
        {`
          .image {
            flex-grow: 1;
            background-image: url(${props.image});
            background-repeat: no-repeat;
            background-size: cover;
            background-position: url(${props.position ? props.position : 'center'});
            height: calc(394vw / 7.5);
          }
          @media screen and (min-width: 1024px) {
            .image {
              flex-grow: 1;
              background-image: url(${props.image});
              background-repeat: no-repeat;
              background-size: cover;
              background-position: ${props.position ? props.position : 'center'};
              height: min(calc(450vw / 19.2), 450px);
            }
          }
        `}
      </style>
    </>
  )
}

const JobBoxContent = (props) => {
  const [link, setLink] = useState([])

  apiFetch({
    path: '/wp-json/wp/v2/applicants/' + props.postid,
  }).then((res) => {
    setLink('/applicants/' + res.slug)
  })

  return (
    <>
      <div className="content">
        <div className="title">{props.title}</div>
        <div className="title-en">{props.titleEN}</div>
        <Btn
          white2={true}
          href={link}
          className={'lg:mt-[40px] mt-[min(calc(40vw/7.5),20px)] z-10'}
        >
          もっと見る
        </Btn>
      </div>
      <style jsx>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;500;600;700&family=Oswald:wght@400;700&display=swap');
          .content {
            background: transparent
              linear-gradient(
                159deg,
                #003475 0%,
                #003678 27%,
                #003e82 48%,
                #004b93 68%,
                #005daa 86%,
                #0070c2 100%
              )
              0% 0% no-repeat padding-box;
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding: calc(52vw / 7.5) 0;
          }
          .title {
            text-align: center;
            font: normal normal bold calc(40vw / 7.5) Noto Sans JP;
            color: #ffffff;
          }
          .title-en {
            font-family: 'Oswald', sans-serif;
            text-align: center;
            font: normal normal min(calc(35vw / 7.5), 18px);
            color: #ffffff;
          }
          .button {
            background: #fff 0% 0% no-repeat padding-box;
            border-radius: 6px;
            width: 335px;
            height: 70px;
            color: #003475;
            margin-left: auto;
            margin-right: auto;
            display: flex;
            text-align: center;
            justify-content: center;
            align-items: center;
            margin-top: 40px;
            position: relative;
            font: normal normal bold 20px/27px Noto Sans JP;
          }
          @media screen and (min-width: 1024px) {
            .content {
              background: transparent
                linear-gradient(
                  159deg,
                  #003475 0%,
                  #003678 27%,
                  #003e82 48%,
                  #004b93 68%,
                  #005daa 86%,
                  #0070c2 100%
                )
                0% 0% no-repeat padding-box;
              width: 100%;
              max-width: calc(634vw / 19.2);
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              padding: 0;
              min-width: 420px;
            }
            .title {
              text-align: center;
              font: normal normal bold calc(50vw / 19.2) Noto Sans JP;
              color: #ffffff;
            }
            .title-en {
              font-family: 'Oswald', sans-serif;
              text-align: center;
              font: normal normal bold calc(20vw / 19.2);
              color: #ffffff;
              margin-top: 2px;
            }
            .button {
              background: #fff 0% 0% no-repeat padding-box;
              border-radius: 6px;
              width: 335px;
              height: 70px;
              color: #003475;
              margin-left: auto;
              margin-right: auto;
              display: flex;
              text-align: center;
              justify-content: center;
              align-items: center;
              margin-top: 40px;
              position: relative;
              font: normal normal bold 20px/27px Noto Sans JP;
            }
          }
        `}
      </style>
    </>
  )
}

function Recruit() {
  const isPC = useMediaQuery({ query: '(min-width: 1024px)' })
  const isMD = useMediaQuery({ query: '(min-width: 768px)' })

  const [cards, setCards] = useState([])
  const [jobs, setJobs] = useState([])
  const [banners, setBanners] = useState([])

  useEffect(() => {
    apiFetch({
      path: `${import.meta.env.VITE_SITE_URL}/wp-json/myroutes/recruit`,
    }).then((res) => {
      setCards(res.interview)
      setJobs(res.jobs)
      setBanners(res.banners)
    })
  }, [])

  return (
    <>
      <img
        src={isMD ? getImageUrl('recruit-header.jpg') : getImageUrl('recruit-header-sp.jpg')}
        alt=""
        className="mx-auto"
      />
      <div className="content-area">
        <Breadcrumb
          current={'採用情報'}
          site_url={import.meta.env.VITE_SITE_URL}
          items={[]}
        />
      </div>
      <div className={isPC ? 'pt-[100px] pb-[240px]' : 'pt-[calc(112vw/7.5)]'}>
        <motion.div
          variants={fadeInBottom}
          initial="hidden"
          whileInView="visible"
          viewport={{
            once: true,
            amount: 0.5,
          }}
        >
          <h2 className="text-[min(calc(50vw/7.5),25px)] lg:text-[80px]">
            施主様の立場に立ち
            <br />
            安全確実に未来に向けた
            <br />
            「造る為の解体工事」を！
          </h2>
        </motion.div>
      </div>
      <div className="section-1 relative !mt-[calc(236vw/7.5)] lg:!mt-0">
        <div className="big-heading">
          <motion.img
            src={getImageUrl('recruit-INTERVIEW.png')}
            alt="INTERVIEW"
            variants={fadeInBottom}
            initial="hidden"
            whileInView="visible"
            viewport={{
              once: true,
              amount: 0.5,
            }}
          />
          <motion.div
            variants={fadeInBottom}
            initial="hidden"
            whileInView="visible"
            viewport={{
              once: true,
              amount: 0.5,
            }}
          >
            <p>私のやりがい</p>
          </motion.div>
        </div>
        <div
          className={clsx({
            'flex justify-center gap-[52px] pl-3 pr-6 mt-[6.5rem]': isPC,
            'grid mt-[calc(80vw/7.5)] max-md:gap-y-[calc(114vw/7.5)] md:grid-cols-2 md:gap-x-12 md:gap-y-16':
              !isPC,
          })}
        >
          <div
            className={clsx(
              { 'pt-[100px]': isPC },
              { 'justify-self-start col-start-2 row-start-1': isMD && !isPC },
              { 'pr-[calc(100vw/7.5)] justify-self-end': !isMD }
            )}
          >
            {cards[0] ? (
              <Card
                ribbon={cards[0].crb_ribbon}
                year={cards[0].crb_year}
                name={cards[0].crb_name}
                nameEN={cards[0].crb_nameen}
                image={cards[0].crb_image}
              >
                {cards[0].crb_content}
              </Card>
            ) : (
              ''
            )}
          </div>
          <div
            className={clsx(
              // isPC ? 'pt-[50px]' : 'pl-[calc(70vw/7.5)]'
              {
                'pt-[50px]': isPC,
              },
              { 'justify-self-end self-center col-start-1 row-start-1 row-span-2': isMD && !isPC },
              {
                'pl-[calc(70vw/7.5)]': !isMD,
              }
            )}
          >
            {cards[1] ? (
              <Card
                ribbon={cards[1].crb_ribbon}
                year={cards[1].crb_year}
                name={cards[1].crb_name}
                nameEN={cards[1].crb_nameen}
                image={cards[1].crb_image}
                delay={0.3}
              >
                {cards[1].crb_content}
              </Card>
            ) : (
              ''
            )}
          </div>
          <div
            className={clsx(
              { 'justify-self-start col-start-2 row-start-2': isMD && !isPC },
              { 'pr-[calc(100vw/7.5)] justify-self-end': !isMD }
            )}
          >
            {cards[2] ? (
              <Card
                ribbon={cards[2].crb_ribbon}
                year={cards[2].crb_year}
                name={cards[2].crb_name}
                nameEN={cards[2].crb_nameen}
                image={cards[2].crb_image}
                delay={0.6}
              >
                {cards[2].crb_content}
              </Card>
            ) : (
              ''
            )}
          </div>
        </div>
      </div>
      <div className="lg:pt-[160px] pt-[calc(120vw/7.5)] lg:pb-[326px]">
        <div className="big-heading relative tracking-tight">
          {isPC && (
            <motion.div
              style={{
                width: 'fit-content',
              }}
              variants={fadeInBottom}
              initial="hidden"
              whileInView="visible"
              viewport={{
                once: true,
                amount: 0.5,
              }}
            >
              <img
                src={getImageUrl('recruit-kowashiro.png')}
                alt=""
                className="absolute w-[11rem] top-[-14rem]  min-[1440px]:w-auto min-[1440px]:top-[-1.25em] min-[1440px]:left-[-16em]"
              />
            </motion.div>
          )}
          <motion.img
            variants={fadeInBottom}
            initial="hidden"
            whileInView="visible"
            viewport={{
              once: true,
              amount: 0.5,
            }}
            src={getImageUrl('recruit-ABOUT-US.png')}
          />
          <motion.div
            variants={fadeInBottom}
            initial="hidden"
            whileInView="visible"
            viewport={{
              once: true,
              amount: 0.5,
            }}
          >
            <p className="break-keep">
              安全に、確実に、
              <wbr />
              顔が見える解体工事
            </p>
          </motion.div>
        </div>
        <div className="lg:content-area mt-[calc(130vw/7.5)] lg:mt-[120px]">
          <motion.img
            src={getImageUrl('recruit-image.jpg')}
            variants={fadeInBottom}
            initial="hidden"
            whileInView="visible"
            viewport={{
              once: true,
              amount: 0.5,
            }}
          />
        </div>

        <div className="mt-[calc(142vw/7.5)] lg:mt-[100px]">
          <motion.div
            variants={fadeInBottom}
            initial="hidden"
            whileInView="visible"
            viewport={{
              once: true,
              amount: 0.5,
            }}
          >
            <p className="paragrah-1">
              横浜総合建設では神奈川県横浜市を中心に、
              {isPC && <br />}
              建物から内装、外構まで幅広い分野にわたる取り壊し工事をご提供しています。
            </p>
            <p className="paragrah-1 mt-[50px]">
              解体工事はすべて自社スタッフと自社保有の重機を中心に解体工事を行っていますので、
              {isPC && <br />}
              スピーディーかつリーズナブルで安全です。
              {isPC && <br />}
              「造るための解体」を理念に、自社スタッフで一丸となって建築業界の一翼を担っています。
            </p>
          </motion.div>
        </div>
      </div>
      <div className="section-1 relative !mt-[calc(236vw/7.5)] lg:!mt-0">
        <div className="big-heading">
          <motion.img
            src={getImageUrl('recruit-BUSINESS.png')}
            alt=""
            variants={fadeInBottom}
            initial="hidden"
            whileInView="visible"
            viewport={{
              once: true,
              amount: 0.5,
            }}
          />
          <motion.div
            variants={fadeInBottom}
            initial="hidden"
            whileInView="visible"
            viewport={{
              once: true,
              amount: 0.5,
            }}
          >
            <p>私たちのしごと</p>
          </motion.div>
        </div>
        <motion.div
          variants={fadeInBottom}
          initial="hidden"
          whileInView="visible"
          viewport={{
            once: true,
            amount: 0.5,
          }}
        >
          <p className="paragrah-1 mt-[3.125rem] lg:mt-[6.25rem]">
            横浜総合建設はこれまで培ってきた経験をスタッフ全員で活かし、
            {isPC && <br />}
            解体工事だけではなく外構工事・造成工事なども承っています。
            {isPC && <br />}
            ただ壊すだけの解体ではなく、お客様のよりよい未来のため、
            {isPC && <br />}
            造ることまで考えた解体工事を提供することを一番に考えています。
          </p>
        </motion.div>
        <div className="grid grid-cols-2 justify-items-center max-w-[714px] lg:max-w-none lg:flex mx-auto justify-center mt-[50px] lg:mt-[100px] gap-[12px] lg:gap-[30px] lg:px-3 px-[calc(70vw/7.5)]">
          <BusinessBoxVer2
            icon={getImageUrl('recruit-icon-1.png')}
            iconClassName="relative bottom-[-12px] left-[8px] lg:bottom-0 lg:left-[7px]"
            title={`建築物解体`}
          />
          <BusinessBoxVer2
            icon={getImageUrl('recruit-icon-2.png')}
            iconClassName=" relative left-[12px] bottom-[-10px] lg:left-[14px] lg:bottom-[-10px]"
            title={`内装解体`}
            delay={0.3}
          />
          <BusinessBoxVer2
            icon={getImageUrl('recruit-icon-3.png')}
            iconClassName="relative lg:bottom-[-14px]"
            title={`外構解体`}
            delay={0.6}
          />
          <BusinessBoxVer2
            icon={getImageUrl('recruit-icon-4.png')}
            iconClassName="relative bottom-[-12px]"
            title={`エクステリア・ <br>造成工事`}
            delay={0.9}
          />
        </div>
      </div>
      <div className="py-[calc(130vw/7.5)] lg:py-[230px]">
        <motion.div
          variants={fadeInBottom}
          initial="hidden"
          whileInView="visible"
          viewport={{
            once: true,
            amount: 0.5,
          }}
        >
          <h2>募集職種</h2>
        </motion.div>
        <div className="mt-[calc(130vw/7.5)] lg:mt-[102px] grid gap-[calc(210vw/7.5)] lg:gap-0">
          {jobs
            ? jobs.map((item, index) => {
                if (index % 2 === 0) {
                  return (
                    <JobBox key={index}>
                      <JobBoxImage
                        image={item.crb_image}
                        position={item.crb_position}
                      />
                      <JobBoxContent
                        title={item.crb_title}
                        titleEN={item.crb_titleen}
                        postid={item.crb_link[0].id}
                      />
                    </JobBox>
                  )
                } else {
                  return (
                    <JobBox key={index}>
                      {isPC ? (
                        <>
                          <JobBoxContent
                            title={item.crb_title}
                            titleEN={item.crb_titleen}
                            postid={item.crb_link[0].id}
                          />
                          <JobBoxImage
                            image={item.crb_image}
                            position={item.crb_position}
                          />
                        </>
                      ) : (
                        <>
                          <JobBoxImage
                            image={item.crb_image}
                            position={item.crb_position}
                          />
                          <JobBoxContent
                            title={item.crb_title}
                            titleEN={item.crb_titleen}
                            postid={item.crb_link[0].id}
                          />
                        </>
                      )}
                    </JobBox>
                  )
                }
              })
            : ''}
        </div>
      </div>
      <div className="section-1 !pt-[calc(130vw/7.5)] lg:!pt-[calc(230vw/19.2)]">
        <motion.div
          variants={fadeInBottom}
          initial="hidden"
          whileInView="visible"
          viewport={{
            once: true,
            amount: 0.5,
          }}
        >
          <h2>会社紹介</h2>
        </motion.div>
        <div className="grid lg:flex justify-center gap-[calc(130vw/7.5)] mt-[calc(130vw/7.5)] lg:mt-[100px] lg:gap-[50px]">
          <Card2
            image={getImageUrl('recruit-company-profile.png')}
            title="会社概要"
            nameEN="COMPANY PROFILE"
            href={`company/#overview`}
          />
          <Card2
            image={getImageUrl('recruit-president.png')}
            title="代表挨拶"
            nameEN="MESSAGE FROM THE PRESIDENT"
            href={`company/#philosophy`}
          />
        </div>
        <div className="flex flex-wrap justify-center gap-[calc(50vw/7.5)] mt-[calc(130vw/7.5)] lg:mt-[150px] px-[calc(70vw/7.5)]">
          {/* <a href="#">
            <img
              src={getImageUrl('doda.png')}
              alt=""
            />
          </a>
          <a href="#">
            <img
              src={getImageUrl('rikunavi.png')}
              alt=""
            />
          </a>
          <a href="#">
            <img
              src={getImageUrl('indeed.png')}
              alt=""
            />
          </a>
          <a href="#">
            <img
              src={getImageUrl('mynavi.png')}
              alt=""
            />
          </a> */}
          {banners
            ? banners.map((item, index) => {
                return (
                  <motion.a
                    key={index}
                    href={item.crb_banner_url}
                    initial={{ scale: 1 }}
                    whileHover={{ scale: 1.1 }}
                  >
                    <img src={item.crb_banner} />
                  </motion.a>
                )
              })
            : ''}
        </div>
      </div>
      <style jsx>{`
        h2 {
          text-align: center;
          font: normal normal bold calc(50vw / 7.5) Noto Sans JP;
          color: #2964b6;
        }
        .button {
          background: #003475 0% 0% no-repeat padding-box;
          border-radius: 6px;
          width: 335px;
          height: 70px;
          color: #fff;
          margin-left: auto;
          margin-right: auto;
          display: flex;
          text-align: center;
          justify-content: center;
          align-items: center;
          margin-top: 100px;
          position: relative;
          font: normal normal bold 20px/27px Noto Sans JP;
        }
        .section-1 {
          background: #f4fbff 0% 0% no-repeat padding-box;
          padding: calc(226vw / 7.5) 0 calc(130vw / 7.5);
        }
        .paragrah-1 {
          text-align: center;
          font-size: 1.1rem;
          padding: 0 calc(70vw / 7.5);
        }
        .big-heading {
          display: grid;
          justify-content: center;
          top: -6.25em;
          left: 0;
          right: 0;
          position: absolute;
          font-size: clamp(5px, 1vw, 16px);
          padding-inline: 0.75rem;
          max-width: 85%;
          width: fit-content;
          margin-inline: auto;
        }
        .big-heading.relative {
          position: relative;
        }
        .big-heading p {
          font-size: max(1.125rem, 4.25vw);
          font-weight: bold;
          color: #003475;
          text-align: center;
          margin-top: 1em;
          letter-spacing: 0.125em;
        }
        .big-heading.tracking-tight p {
          letter-spacing: 1px;
        }
        @media (min-width: 1024px) {
          h2 {
            text-align: center;
            font: normal normal bold 80px/100px Noto Sans JP;
            color: #2964b6;
          }
          .button {
            background: #003475 0% 0% no-repeat padding-box;
            border-radius: 6px;
            width: 335px;
            height: 70px;
            color: #fff;
            margin-left: auto;
            margin-right: auto;
            display: flex;
            text-align: center;
            justify-content: center;
            align-items: center;
            margin-top: 100px;
            position: relative;
            font: normal normal bold 20px/27px Noto Sans JP;
          }
          .section-1 {
            background: #f4fbff 0% 0% no-repeat padding-box;
            padding: 220px 0;
            margin-top: 0;
          }
          .paragrah-1 {
            text-align: center;
            font: normal normal normal 24px/50px Noto Sans JP;
            padding: 0;
          }
          .big-heading p {
            font-size: 2.35em;
          }
        }
      `}</style>
    </>
  )
}

export default Recruit
